import React from 'react';
import * as FiIcons from 'react-icons/fi';

const SafeIcon = ({ icon: IconComponent, name, ...props }) => {
  // If a component is passed directly
  if (IconComponent) {
    return <IconComponent {...props} />;
  }

  // If a name string is passed (e.g., "Home" for FiHome)
  if (name) {
    const Icon = FiIcons[`Fi${name}`];
    if (Icon) return <Icon {...props} />;
  }

  // Fallback icon
  return <FiIcons.FiAlertTriangle {...props} />;
};

export default SafeIcon;